import { NavigationItemsProvider } from "./app/NavigationItemsContext";
import { ApplicationProvider } from "./app/ApplicationsContext";
import { AccountsProvider } from "./app/AccountsContext";
import { ApplicationManagerContextProvider } from "./app/ApplicationManagerContext";
import SnackbarContextProvider from "./app/SnackbarContext";
import { SysadminContextProvider } from "./app/SysadminContext";
import { SeatApplicationManagerContextProvider } from "./app/SeatApplicationManagerContext";
import { AppContextProvider } from "./app/AppContext";

const AppContexts = ({ children }) => {
  return (
    <AppContextProvider>
      <AccountsProvider>
        <NavigationItemsProvider>
          <SysadminContextProvider>
            <ApplicationProvider>
              <ApplicationManagerContextProvider>
                <SeatApplicationManagerContextProvider>
                  <SnackbarContextProvider>
                    {children}
                  </SnackbarContextProvider>
                </SeatApplicationManagerContextProvider>
              </ApplicationManagerContextProvider>
            </ApplicationProvider>
          </SysadminContextProvider>
        </NavigationItemsProvider>
      </AccountsProvider>
    </AppContextProvider>
  );
};

export default AppContexts;
